import React from 'react';
import SmartDialog from "../SmartDialog/SmartDialog";
import {ListItemView, PaginatedView} from "../PaginatedView/PaginatedView";
import TTLProxy from "../../common/TTLAsyncProxy";
import {PermissionsEndpoint, UsersEndpoints} from "../../common/ProxyEndpoints";
import MDSpinner from 'react-md-spinner';
import Utils from "../../common/Utils";
import {Alert, Badge, Button, ButtonToolbar, Label, UncontrolledAlert, UncontrolledTooltip} from 'reactstrap';
import {ErrorDisplay} from "../../views/Register/RegisterBase";
import MDProgress from 'react-md-progress-bar';
import moment from "moment";
import {UserRoles} from "../../common/Constants";
import HTML from '../../common/HtmlHelpers';
import ManageDepartmentDialog from "../ManageDepartmentDialog/ManageDepartmentDialog";
import PropTypes from 'prop-types';
import {css} from "glamor";
import _ from 'lodash';
import Icon from 'react-icons-kit';
import {ic_more_vert as MoreVertIcon} from 'react-icons-kit/md/ic_more_vert'
import AlertConfigurationDialog from "../AlertsConfigurationDialog/AlertConfigurationDialog";
import AppVariables from '../../common/AppVariables';
import {ActionSelectDialog} from "../ActionSelectDialog/ActionSelectDialog";

const UserOpts = {
    include: ["status"]
};

const permissionItemStyle = css({

    '&:hover':{
      backgroundColor: "#eeeeee"
    }

});

const Styles = {

    actionBtn: {
        marginRight: 5,
        fontSize: 12,
        borderRadius: 5
    },

    infoFrame : {
        padding: 0,
        marginBottom: 0
    },

    filterBtn:{
        padding: 6,
        borderRadius: 16,
        marginRight: 4,
        fontSize: 12
    },

    searchInput:{
        paddingTop: 5,
        paddingBottom: 5,
        paddingLeft: 14,
        paddingRight: 14,
        borderRadius: 10,
        minWidth: 300,
    },

    executeBtn:{
        borderRadius: 4
    }

};




class PermissionsManagementDialog extends React.Component{

    static propTypes = {
        onUpdatePermissions: PropTypes.func
    };

    constructor(props){
        super(props);
        this.state = PermissionsManagementDialog.getInitialState();
        this.proxy = TTLProxy.getInstance();
        this.onUpdatePermissions = this.onUpdatePermissions.bind(this);
    }

    static getInitialState(state){

        return {
            isBusy: false,
            error: null,
            permissions: [],
            filteredPermissions: [],
            search: "",
            userPermissions: state ? _.clone(state.user.permissions) : [],
            user: state ? state.user : null,
            hasChanges: false
        };

    }

    _filterPermissions(permissions,search){

        const containsText = (text,kwd) => {
            return text.toLowerCase().indexOf(kwd.toLowerCase()) >= 0;
        };

        return permissions.filter(p => {
            return containsText(PermissionsManagementDialog.formatPermissionName(p.name),search) || containsText(p.description,search);
        });

    }

    onSearchChanged(search){

        this.setState(state => ({
            search,
            filteredPermissions: search ? this._filterPermissions(state.permissions,search) : state.permissions
        }));

    }

    async loadState(){

        const { user , search } = this.state;

        this.setState({
            isBusy: true,
            error: null
        });

        try {

            const res = await this.proxy.processRequest(PermissionsEndpoint.getForUserRole(user.role));
            const permissions = res.getPayload();

            this.setState({
                permissions,
                filteredPermissions: search ? this._filterPermissions(permissions,search) : permissions
            });

        }
        catch (e) {

            this.setState({
                error: e
            });
        }
        finally {
            this.setState({ isBusy : false })
        }
    }

    async onUpdatePermissions(){

        const { user  , userPermissions }  = this.state;

        this.setState({ isBusy: true, error: null });

        try {

            const res = await this.proxy.processRequest(PermissionsEndpoint.setUserPermissions(user.id, userPermissions));
            if(res.ok){

                //  toast success
                HTML.toastSuccess('Permissions updated successfully');

                //
                if(this.props.onUpdatePermissions){
                    this.props.onUpdatePermissions(user,userPermissions);
                }

                //  hide dialog
                this._dlg.hide();
            }
        }
        catch (e) {

            HTML.toastError(Utils.getResponseError(e));

            this.setState({
                error: e
            });

        }
        finally {
            this.setState({ isBusy: false });
        }
    }


    show(user){

        this.setState(PermissionsManagementDialog.getInitialState({ user }), () => {

            //
            this._dlg.show();

            //
            return this.loadState();

        });

    }

    static formatPermissionName(perm){
        return perm.replace("perm_","").split("_").map(x => Utils.ucFirst(x)).join(" ");
    }

    render(){

        const { error , permissions , filteredPermissions , userPermissions , hasChanges ,  isBusy } = this.state;

        return <SmartDialog ref={r => this._dlg = r} title="Permissions Management" showCancelButton={false}>

            <input type="text" name="search" placeholder={"Search for permissions..."} className="form-control form-input-select" value={this.state.search} onChange={evt => {
                this.onSearchChanged(evt.target.value);
            }}/>

            {userPermissions.length === 0 && <Alert color="warning"><i className="fa fa-exclamation-triangle"/> User account must poses at least one permission to be functional</Alert>}
            <hr/>

            <PaginatedView data={filteredPermissions}
                           rowHeight={138}
                           renderItem={(item,k) =>{

                               return <div className={`${permissionItemStyle}`}>

                                   <div className="p-3">
                                       <div className="clearfix">

                                           <div className="pull-left">
                                               <h6>{PermissionsManagementDialog.formatPermissionName(item.name)}</h6>
                                           </div>

                                           <div className="pull-right">
                                               <label className="form-check-inline">
                                                   <input type="checkbox" checked={userPermissions.includes(item.name)} onChange={evt => {

                                                       const checked  = evt.target.checked;
                                                       if(checked){
                                                           userPermissions.push(item.name);
                                                       }
                                                       else{
                                                           userPermissions.splice(userPermissions.findIndex(x => item.name === x),1);
                                                       }

                                                       this.setState({
                                                           userPermissions,
                                                           hasChanges: true
                                                       });

                                                   }} />
                                               </label>
                                           </div>

                                       </div>
                                       <p style={{ color: "#4b4b4b" }}>{item.description}</p>
                                   </div>
                               </div>
                           }}
                           height={380}
                           noRowsHeight={150}
                           emptyMessage={"No permissions available"}/>

            {error && <UncontrolledAlert color={"danger"}><i className="fa fa-exclamation-triangle"/> {Utils.getResponseError(error)}</UncontrolledAlert>}

            <hr/>

            {isBusy && <MDProgress show/>}

            <div className="clearfix">
                <div className="pull-right">
                    <span>
                        <Button color="green" className="mr-1" disabled={!hasChanges || userPermissions.length === 0} onClick={() => this.onUpdatePermissions()}><i className="fa fa-save"/> Save</Button>
                        <Button onClick={() => this._dlg.hide()}><i className="fa fa-close"/> Cancel</Button>
                    </span>
                </div>
            </div>

        </SmartDialog>
    }

}

class ConfirmActionDialog extends React.Component{

    static propTypes = {
        confirmStatement: PropTypes.any,
        message: PropTypes.any,
        processActionText : PropTypes.string,
        processIcon : PropTypes.any,
        title: PropTypes.string,
        onExecute: PropTypes.func
    };

    constructor(props){
        super(props);
        this.state = {
            isBusy: true,
            allowExecute: false,
            user: null
        };
    }

    onExecute(){

        const user = this.state.user;
        const props = this.props;
        const dlg = this.dlg;

        if(props.onExecute){

            props.onExecute(user).then(() => {
                dlg.toggle();
            });

        }
    }

    show(user){

        this.setState({
            allowExecute: false,
            isBusy: false,
            user: user,
        });

        //  Show dialog
        this.dlg.show();
    }

    render(){

        const user = this.state.user;
        return <SmartDialog ref={r => this.dlg = r} title={this.props.title}>
            <div>
                {typeof this.props.message == "function"  ? ( user ?  this.props.message(user) : null ) : this.props.message }
                <Label>
                    <input type="checkbox" defaultChecked={false} onChange={(evt) => {

                        this.setState({
                            allowExecute: evt.target.checked
                        });

                    }}/> {this.props.confirmStatement}

                </Label>
                {this.state.isBusy && <MDProgress show={true} ovelay={true}/>}
                <Button color={"primary"} block style={Styles.executeBtn} disabled={!this.state.allowExecute} onClick={() => this.onExecute() }>{HTML.renderIcon(this.props.processIcon)} {this.props.processActionText}</Button>
            </div>
        </SmartDialog>
    }

}

/**
 * Account Control
 */
class AccountControlDialog extends React.Component{

    constructor(props){
        super(props);
        this.state = this.getInitialState();

        //  Get proxy reference
        this.proxy = TTLProxy.getInstance();

        //  The current user in context
        this.operationalUser = null;
    }

    getInitialState(){
        return {
            users: [],
            usersFiltered: [],
            activitySummary: {
                totalActive: 0,
                totalInactive: 0,
                totalUsers: 0
            },
            isBusy: false,
            isLoaded: false,
            errorMessage: null,
            filters: {
                includeFBO: true,
                includeOwner: true,
                includeAdmin: true,
                includeFarmer: true,
                searchKeyword: null
            }
        };
    }

    show(){

        const me = this;

        this.setState(this.getInitialState());

        //
        this.operationalUser = null;

        //  Load state
        this.loadState().then(() => {

            //
            me.setState({
                isLoaded:  true
            });

        });

        //  Show dialog
        this._dlg.show();
    }

    fetchUser(userId){

        const me = this;
        return this.proxy.processRequest( UsersEndpoints.get(userId).url, UserOpts ).then(response => {

            const user = response.getPayload();
            user._fullname = Utils.getUserName(user);

            let users = me.state.users;
            const _index  = users.findIndex(x => x.id == userId);
            if(_index >= 0){
                users[_index] = user;
                this.setUsers(users);
            }

        }).catch(err => {
            console.log("Failed fetching updated user. Try refreshing page");
        });

    }


    setUsers(payload){

        for(let i = 0 , len = payload.length ;  i< len ; i++){
            payload[i]._fullname = Utils.getUserName(payload[i]);
        }

        const filtered = this.filterUsers(payload,this.state.filters);

        this.setState({
            users: payload,
            usersFiltered: filtered
        });

    }

    /**
     * Loads the current account state
     */
    loadState(){

        this.setState({
            isBusy: true,
            errorMessage: null
        });

        const me = this;
        const proxy = this.proxy;

        return Promise.all([

            //  Fetch all users
            proxy.processRequest(UsersEndpoints.getUrl() , UserOpts ).then(response => {

                //  set users
                this.setUsers(response.getPayload());

            }),

            //  Fetch activity summary
            proxy.processRequest(UsersEndpoints.getActivitySummary()).then(response =>{

                me.setState({
                    activitySummary: response.getPayload()
                });

            })



        ]).then(() =>{

            me.setState({
                isBusy: false
            });

        }).catch(err => {

            me.setState({
                isBusy: false,
                errorMessage: Utils.getResponseError(err)
            });

        })


    }

    static roleToAccountType(role){

        switch (role){
            case UserRoles.Admin:
                return "Administrator";
            case UserRoles.Owner:
                return "Tractor Owner";
            case UserRoles.FBO:
                return "FBO";
            case UserRoles.CallCenterAgent:
                return "Call Center Agent";
            case UserRoles.Farmer:
                return  "Farmer";
        }
    }

    refreshUser(id){

        return this.proxy.processRequest(UsersEndpoints.get(id).url,UserOpts).then(response =>{

            if(response.ok){

                const users = this.state.users;
                const user = response.getPayload();
                const index = users.findIndex(x => x.id == id);
                if(index >= 0){

                    users[index] = user;

                    this.setState({
                        users: users,
                        usersFiltered: this.filterUsers(users,this.state.filters)
                    });
                }


            }

        })
    }

    filterUsers(users , filters){

        let filtered = [];
        for(let i = 0 ,len = users.length ; i < len ; i++){
            const user = users[i];

            if(!filters.includeAdmin && user.role === UserRoles.Admin)
                continue;

            if(!filters.includeFBO && user.role === UserRoles.FBO)
                continue;

            if(!filters.includeOwner && user.role === UserRoles.Owner)
                continue;

            if(!filters.includeFarmer && user.role === UserRoles.Farmer)
                continue;

            if(filters.searchKeyword && user._fullname.toLowerCase().indexOf(filters.searchKeyword.toLowerCase()) < 0){
                continue;
            }

            filtered.push(user);
        }

        return filtered.sort((a,b) => a._fullname.localeCompare(b._fullname) );
    }

    onSearchChanged(evt){

        const filters = this.state.filters;
        filters.searchKeyword = evt.target.value;

        this.setState({
            filters: filters,
            usersFiltered: this.filterUsers(this.state.users , filters)
        });

    }

    toggleInclude(include){

        let filters = this.state.filters;
        switch (include){
            case "admin":
                filters.includeAdmin = !filters.includeAdmin;
                break;
            case "fbo":
                filters.includeFBO = !filters.includeFBO;
                break;
            case "owner":
                filters.includeOwner = !filters.includeOwner;
                break;
            case "farmer":
                filters.includeFarmer = !filters.includeFarmer;
                break;
        }

        //  update filter
        this.setState({
            filters: filters,
            usersFiltered: this.filterUsers(this.state.users,  filters)
        });

    }

    isIncluded(include){

        switch (include){
            case "admin":
                return this.state.filters.includeAdmin;
            case "fbo":
                return this.state.filters.includeFBO;
            case "owner":
                return this.state.filters.includeOwner;
            case "farmer":
                return  this.state.filters.includeFarmer;
        }
    }

    showActionDialog(dlg, user){

        switch (dlg){
            case "reset-password":
                this._resetPasswordDlg.show(user);
                break;
            case "lock":
                this._lockAccountDlg.show(user);
                break;
            case "unlock":
                this._unlockAccountDlg.show(user);
                break;
            case "activate":
                this._activateAccountDlg.show(user);
                break;
        }

    }

    handleOperationStatus(promiseStatus , successMsg , userId){

        return promiseStatus.then(response => {

            if(response.ok){

                //
                if(userId !== undefined){
                    this.refreshUser(userId);
                }

                //
                HTML.toastMessage(successMsg);
                return true;
            }

        }).catch(err =>{
            HTML.toastError(Utils.getResponseError(err));
        });
    }

    onLockUserAccount(user){
        return this.handleOperationStatus( this.proxy.processRequest(UsersEndpoints.adminLockUserAccount(user.id)) , "Account lock completed successfully!", user.id);
    }

    onResetUserPassword(user){
        return this.handleOperationStatus( this.proxy.processRequest(UsersEndpoints.adminResetPassword(user.id,AppVariables.DefaultDispatchMode)) , "Password reset completed successfully!",user.id);
    }

    onUnlockUserAccount(user){
        return this.handleOperationStatus( this.proxy.processRequest(UsersEndpoints.adminUnlockAccount(user.id)) , "Account unlocked successfully",user.id);
    }

    onActivateUserAccount(user){
        return this.handleOperationStatus( this.proxy.processRequest(UsersEndpoints.adminActivateAccount(user.id,AppVariables.DefaultDispatchMode)) , "Account activated successfully",user.id);
    }

    render(){

        const state= this.state;
        const users = state.usersFiltered;
        const isLoaded = state.isLoaded;
        const isBusy = state.isBusy;

        return <SmartDialog ref={r => this._dlg = r} title={"Account Control Management"} showCancelButton={true} large={true}>

            { (isBusy && !isLoaded) ? <div className="text-center">
                    <MDSpinner size={40}/>
                    <p>Please hold... Loading users</p>
                </div> :
                <div>

                    <div className="clearfix">

                        <div className="pull-left">
                            <h6> <Badge pill={true} color={"info"}>Total Users: <b>{users.length}</b> </Badge> </h6>
                        </div>

                        <div className="pull-right">
                            <h6> <Badge pill={true} color="success">Online : <b>{state.activitySummary.totalActive}</b></Badge>
                                <Badge pill={true}>Offline: <b>{state.activitySummary.totalInactive}</b></Badge> </h6>
                        </div>

                    </div>

                    <hr/>

                    <div className="clearfix" style={{marginBottom: 10}}>

                        <div className="pull-left">

                            <input type="text"
                                   style={Styles.searchInput}
                                   className="form-control form-input-select"
                                   placeholder="Search users..."
                                   onChange={this.onSearchChanged.bind(this)} />

                        </div>

                        <div className="pull-right">

                            <ButtonToolbar>
                                <Button outline={!this.isIncluded("admin")} style={Styles.filterBtn} onClick={() => this.toggleInclude("admin")} color={"primary"}>{this.isIncluded("admin") && <i className="fa fa-check"></i>} Admin</Button>
                                <Button outline={!this.isIncluded("fbo")} style={Styles.filterBtn} onClick={() => this.toggleInclude("fbo")} color={"primary"}>{this.isIncluded("fbo") && <i className="fa fa-check"></i>} FBO</Button>
                                <Button outline={!this.isIncluded("owner")} style={Styles.filterBtn} onClick={() => this.toggleInclude("owner")} color={"primary"}>{this.isIncluded("owner") && <i className="fa fa-check"></i>} Tractor Owner</Button>
                                <Button outline={!this.isIncluded("farmer")} style={Styles.filterBtn} onClick={() => this.toggleInclude("farmer")} color={"primary"}>{this.isIncluded("farmer") && <i className="fa fa-check"></i>} Farmer</Button>
                                <div style={{backgroundColor: "#cecece" , width: 1 , marginLeft: 2 , marginRight: 6 }}/>
                                <Button onClick={() => this.loadState() } color={"secondary"} style={Styles.filterBtn}><i className="fa fa-refresh"></i> Refresh</Button>

                            </ButtonToolbar>

                        </div>

                    </div>

                    <ActionSelectDialog ref={r => this._actionDlg = r}/>

                    <PaginatedView emptyMessage="There's nothing here. Try changing filters or search keyword."
                                   height={350}
                                   rowHeight={120}
                                   noRowsHeight={350}
                                   renderItem={user => {

                                       const name = Utils.getUserName(user);
                                       const entity = Utils.getUserEntity(user);
                                       const isSuperUser = Utils.hasRole(user.role, UserRoles.Admin) && user.admin.super_user;
                                       return <ListItemView avatarName={name}
                                                            media={entity ?  entity.media : null}
                                                            title={<div className="clearfix">
                                                                <h6 className="pull-left">{name} {isSuperUser && <Badge pill color="danger"><i className="fa fa-home"/> Super Admin</Badge>}</h6>
                                                                <div className="pull-right">
                                                                    {!isSuperUser && <Button  color={"link"} className="mr-3" size="sm" onClick={() => this._actionDlg.show([
                                                                        {
                                                                            label: "Activate Account",
                                                                            disabled: user.active,
                                                                            icon: "fa fa-bolt",
                                                                            onClick: () => {
                                                                                this.showActionDialog("activate",user);
                                                                            }
                                                                        },
                                                                        {
                                                                            label: `${user.locked ? "Unlock" : "Lock"} Account`,
                                                                            icon: user.locked ? "fa fa-unlock" : "fa fa-lock",
                                                                            onClick: () =>{
                                                                                this.showActionDialog(user.locked ? "unlock" : "lock", user);
                                                                            }
                                                                        },
                                                                        {
                                                                            label: "Reset Password",
                                                                            icon:  "fa fa-refresh",
                                                                            disabled: !user.active || user.locked,
                                                                            onClick: () => {
                                                                                this.showActionDialog("reset-password",user);
                                                                            }
                                                                        },
                                                                        {
                                                                            label: "Configure Departments",
                                                                            icon: "fa fa-university",
                                                                            disabled: !Utils.hasRole(user.role ,UserRoles.Admin),
                                                                            onClick: () => {
                                                                                this._departmentManagementDlg.show(user.admin);
                                                                            }
                                                                        },
                                                                        {
                                                                            label: "Manage Permissions",
                                                                            icon: "fa fa-chain-broken",
                                                                            onClick: () => {
                                                                                this._permissionDlg.show(user);
                                                                            }
                                                                        },
                                                                        {
                                                                            label: "Alerts & Notification Settings",
                                                                            icon: "fa fa-bell",
                                                                            onClick: () => {
                                                                                this._alertConfigDlg.show(user);
                                                                            }
                                                                        }
                                                                    ])}>
                                                                        <Icon icon={MoreVertIcon}/>
                                                                    </Button>}
                                                                    {/*{!isSuperUser && <UncontrolledDropdown style={{marginTop: -2}} className="mr-3" size={"sm"}>
                                                                         <DropdownToggle caret/>
                                                                         <DropdownMenu right>
                                                                             <DropdownItem color={user.active ? "secondary" : "primary"} disabled={user.active} onClick={() => this.showActionDialog("activate",user) }><i className="fa fa-lightbulb-o"/> Activate</DropdownItem>
                                                                             <DropdownItem color={"primary"} onClick={() => { this.showActionDialog(user.locked ? "unlock" : "lock", user) }}><i className={user.locked ? "fa fa-unlock" : "fa fa-lock"}/> {user.locked ? "Unlock" : "Lock"}</DropdownItem>
                                                                             <DropdownItem color={(!user.active || user.locked) ? "secondary" : "primary"} disabled={!user.active || user.locked} onClick={() => this.showActionDialog("reset-password",user) }><i className="fa fa-refresh"/> Reset Password</DropdownItem>
                                                                             {Utils.hasRole(user.role ,UserRoles.Admin) && <DropdownItem color={"primary"} onClick={() => this._departmentManagementDlg.show(user.admin) }><i className="fa fa-university"/> Departments</DropdownItem>}
                                                                         </DropdownMenu>
                                                                     </UncontrolledDropdown>}*/}
                                                                </div>

                                                            </div> }
                                                            subheader={<div className="pull-left">
                                                                <div style={Styles.infoFrame}><b>Account Type:</b> {AccountControlDialog.roleToAccountType(user.role)}</div>
                                                                <div style={Styles.infoFrame}><b>Registered:</b> {moment(user.date_created).format("DD/MM/YYYY")}</div>
                                                                <div style={Styles.infoFrame}><b>Activity Status:</b> {HTML.renderUserActivityStatus(user, { display: "inline" } )}</div>
                                                            </div>}/>
                                   }}
                                   data={users}/>

                    { (isBusy && isLoaded) && <MDProgress show={true} overlay={true}/> }


                </div>}

            {this.state.errorMessage && <ErrorDisplay error={this.state.errorMessage}/>}


            <AlertConfigurationDialog ref={r => this._alertConfigDlg = r}
                                      onNotificationsUpdated={user => this.fetchUser(user.id)}/>

            {/*Permission Management Dialog*/}
            <PermissionsManagementDialog onUpdatePermissions={(user,permissions) =>{
                this.fetchUser(user.id);
            }} ref={r => this._permissionDlg = r}/>

            {/*Lock account*/}
            <ConfirmActionDialog ref={r => this._lockAccountDlg = r}
                                 title="Lock Account"
                                 processActionText="Lock Account"
                                 processIcon="fa fa-lock"
                                 confirmStatement={<span>I know what this means, <b>Continue</b></span>}
                                 message={user => {
                                     return (<div>
                                         <p>You are about to lock the user account for <a href="#" id="lbUserName"><b>{user ?  Utils.getFirstName(user._fullname) : null}</b></a> <UncontrolledTooltip target="lbUserName" placement="bottom">Name: {user._fullname}</UncontrolledTooltip>. It is worth noting that the user will not be granted access to perform any operation after the process is complete. If you're not sure about this procedure, please cancel or hit the escape button</p>
                                         <p>To proceed with operation. Select the check button below</p>
                                     </div>);
                                 }}
                                 onExecute={this.onLockUserAccount.bind(this)} />

            {/* Unlock Account Dialog */}
            <ConfirmActionDialog ref={r => this._unlockAccountDlg = r}
                                 title="Unlock Account"
                                 processActionText="Unlock"
                                 processIcon="fa fa-unlock"
                                 confirmStatement={<span>Proceed with unlock</span>}
                                 message={user => {
                                     return (<div>
                                         <p>Unlock account for <a href="#" id="lbUserName"><b>{user ?  Utils.getFirstName(user._fullname) : null}</b></a> <UncontrolledTooltip target="lbUserName" placement="bottom">Name: {user._fullname}</UncontrolledTooltip>. After the operation is complete, the user will be granted full access to allowed operations and control. If you're not sure about this procedure, please cancel or hit the escape button</p>
                                         <p>To proceed with operation. Select the check button below</p>
                                     </div>);
                                 }}
                                 onExecute={this.onUnlockUserAccount.bind(this)} />

            {/* Activate Account Dialog */}
            <ConfirmActionDialog ref={r => this._activateAccountDlg = r}
                                 title="Activate Account"
                                 processActionText="Activate"
                                 processIcon="fa fa-lightbulb"
                                 confirmStatement={<span>Continue activation</span>}
                                 message={user => {
                                     return (<div>
                                         <p>Activate account for <a href="#" id="lbUserName"><b>{user ?  Utils.getFirstName(user._fullname) : null}</b></a> <UncontrolledTooltip target="lbUserName" placement="bottom">Name: {user._fullname}</UncontrolledTooltip>. This operation will send an activation code to the user for confirmation. If you're not sure about this procedure, please cancel or hit the escape button</p>
                                         <UncontrolledAlert color="info">
                                             {this.proxy.isSuperUser() ? <div><b>Note:</b> Account will be activated
                                                     immediately. Operation will <b>not</b> send notifications after
                                                     completion</div> :
                                                 <div><b>Note:</b> You must be a super user before the operation can be
                                                     performed</div>}
                                         </UncontrolledAlert>
                                         <p>To proceed with operation. Select the check button below</p>
                                     </div>);
                                 }}
                                 onExecute={this.onActivateUserAccount.bind(this)} />

            {/* Reset Password Dialog */}
            <ConfirmActionDialog ref={r => this._resetPasswordDlg = r}
                                 title="Reset Password"
                                 processActionText="Reset Password"
                                 processIcon="fa fa-refresh"
                                 confirmStatement={<span>Proceed with reset</span>}
                                 message={user => {
                                     return (<div>
                                         <p>Are you sure you really want to issue a password reset for <a href="#" id="lbUserName"><b>{user ?  Utils.getFirstName(user._fullname) : null}</b></a> <UncontrolledTooltip target="lbUserName" placement="bottom">Name: {user._fullname}</UncontrolledTooltip>. The user will be sent the newly generated password after the operation is complete. If you're not sure about this procedure, please cancel or hit the escape button</p>
                                         <p>To proceed with operation. Select the check button below</p>
                                     </div>);
                                 }}
                                 onExecute={this.onResetUserPassword.bind(this)} />

            <ManageDepartmentDialog ref={r => this._departmentManagementDlg = r}
                                    onUpdate={admin => this.fetchUser( this.state.users.find(x => x.role == UserRoles.Admin && x.admin.id == admin.id).id )}/>

        </SmartDialog>

    }

}

export default AccountControlDialog;



// WEBPACK FOOTER //
// ./src/components/AccountControlDialog/AccountControlDialog.js